import { render } from "./Forms.vue?vue&type=template&id=641db86a"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
script.render = render

export default script